import { render, staticRenderFns } from "./historialCambios.vue?vue&type=template&id=b639d404&scoped=true"
import script from "./historialCambios.vue?vue&type=script&lang=js"
export * from "./historialCambios.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b639d404",
  null
  
)

export default component.exports